import { render, staticRenderFns } from "./SearchTermsPage.vue?vue&type=template&id=39577638&scoped=true&"
import script from "./SearchTermsPage.vue?vue&type=script&lang=js&"
export * from "./SearchTermsPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchTermsPage.vue?vue&type=style&index=0&id=39577638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39577638",
  null
  
)

export default component.exports